/** Confirmed public contact details; shared by UI, schemas and generation. */
export const OFFICIAL_EMAIL = "ofir370h@gmail.com";
export const TECHNICIAN_NAME_EN = "Ofir Hershco";
export const TECHNICIAN_NAME_HE = "אופיר הרשקו";
export const SERVICE_LANGUAGES = ["he", "en", "ru", "hi", "si", "ta", "th"];